import _objectSpread from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  style: {
    "text-align": "center",
    "margin-top": "10%"
  }
};
var _hoisted_2 = {
  ref: "spanEl",
  style: {
    "color": "#00aeff"
  }
};
var _hoisted_3 = {
  style: {
    "color": "#F6416C"
  }
};
import useStore from '@/store';
import { computed } from 'vue';
import { defineComponent as __MACROS_defineComponent } from "vue";
var __default__ = __MACROS_defineComponent({
  name: 'Home'
});
export default /*@__PURE__*/_defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  setup: function setup(__props) {
    var store = useStore();
    var profile = computed(function () {
      return store.user.profile;
    });
    return function (_ctx, _cache) {
      var _component_XAppLayout = _resolveComponent("XAppLayout");
      return _openBlock(), _createBlock(_component_XAppLayout, null, {
        default: _withCtx(function () {
          var _profile$value;
          return [_createElementVNode("h1", _hoisted_1, [_createElementVNode("span", _hoisted_2, "您好！", 512), _cache[0] || (_cache[0] = _createTextVNode()), _createElementVNode("span", _hoisted_3, _toDisplayString((_profile$value = profile.value) === null || _profile$value === void 0 ? void 0 : _profile$value.nickname), 1)])];
        }),
        _: 1
      });
    };
  }
}));